import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import PlaceholderImage from "@/components/PlaceholderImage";
import SectionReveal from "@/components/SectionReveal";
import { PAGE_BANNERS } from "@/data/assets";

const CONTACT_CARDS = [
  { label: "Seller",      value: "info@adsgallery.com",           href: "mailto:info@adsgallery.com",           icon: Mail,  testId: "contact-seller-email",
    note: "For orders, listings and shipping-related queries on Amazon India."
  },
  { label: "Distributor", value: "info@musclepronutrition.com",   href: "mailto:info@musclepronutrition.com",   icon: Mail,  testId: "contact-distributor-email",
    note: "For distribution, wholesale, licensing and general brand queries."
  },
  { label: "Phone",       value: "+91 9136048500",                href: "tel:+919136048500",                    icon: Phone, testId: "contact-phone",
    note: "Monday to Saturday, 10:00 AM – 6:00 PM IST."
  },
];

export default function Contact() {
  return (
    <>
      {/* CONTACT BANNER */}
      <section data-testid="contact-hero" className="bg-white">
        <div className="relative">
          <PlaceholderImage
            label="Contact Page Banner"
            ratio="aspect-[21/9]"
            tone="dark"
            testId="contact-banner"
            src={PAGE_BANNERS.contact}
            alt="Contact MusclePharm India"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-transparent" />
          <div className="absolute inset-0 mp-container flex items-center">
            <div className="text-left w-full max-w-4xl">
              <div
                className="font-heading uppercase tracking-[0.32em] text-[11px] mb-4 font-semibold"
                style={{ color: "var(--mp-green)" }}
              >
                Contact
              </div>
              <h1 className="font-display text-5xl sm:text-7xl lg:text-8xl uppercase leading-[0.9] text-white">
                Get in touch.
              </h1>
              <p className="mt-6 max-w-xl font-body text-white/90 text-lg leading-relaxed">
                For product enquiries, distribution partnerships, returns and general questions — reach out through the channels below and we will get back to you within one business day.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT CARDS */}
      <section data-testid="contact-cards" className="bg-white py-20 lg:py-24">
        <div className="mp-container">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {CONTACT_CARDS.map((c, i) => (
              <SectionReveal key={c.label} delay={i * 100}>
                <a
                  href={c.href}
                  data-testid={c.testId}
                  className="group block h-full bg-white border border-black/10 hover:border-black p-8 transition-colors"
                >
                  <div className="w-12 h-12 flex items-center justify-center border border-black/15 group-hover:bg-black group-hover:border-black group-hover:text-white transition-colors text-black">
                    <c.icon size={18} />
                  </div>
                  <div className="mt-6 font-heading uppercase tracking-[0.24em] text-[11px] text-black/50 font-semibold">
                    {c.label}
                  </div>
                  <div className="mt-2 font-display text-2xl sm:text-3xl uppercase leading-none break-words text-black">
                    {c.value}
                  </div>
                  <p className="mt-3 font-body text-black/60 text-sm leading-relaxed">
                    {c.note}
                  </p>
                </a>
              </SectionReveal>
            ))}
          </div>
        </div>
      </section>

      {/* ADDRESS */}
      <section data-testid="contact-address" className="bg-[color:var(--mp-off-white)] py-20 lg:py-24">
        <div className="mp-container grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <SectionReveal className="lg:col-span-7">
            <div className="mp-eyebrow-green">Registered Address</div>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95]">
              Where to find us
            </h2>
            <p className="mt-8 font-body text-black/80 leading-relaxed text-lg max-w-2xl">
              Unit No. 339, Building F, Kanakia Zillion, near the CST Junction on LBS Marg, Mumbai, Maharashtra, India.
            </p>
            <p className="mt-4 font-body text-black/70 leading-relaxed max-w-2xl">
              For all in-person meetings and courier deliveries, please write to us in advance to coordinate a time. Our office observes standard Indian public holidays.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <a href="mailto:info@musclepronutrition.com" data-testid="contact-cta-email" className="mp-btn mp-btn-primary">
                Email Us
              </a>
              <a href="tel:+919136048500" data-testid="contact-cta-call" className="mp-btn mp-btn-outline">
                Call: +91 9136048500
              </a>
            </div>
          </SectionReveal>

          <SectionReveal delay={120} className="lg:col-span-5">
            <div className="border border-black/10 bg-white p-8">
              <div
                className="w-14 h-14 flex items-center justify-center border"
                style={{ borderColor: "var(--mp-green)", color: "var(--mp-green-hover)" }}
              >
                <MapPin size={26} />
              </div>
              <h3 className="mt-6 font-display text-2xl uppercase leading-none">
                MusclePro Nutrition
              </h3>
              <p className="mt-4 font-body text-black/75 leading-relaxed">
                Exclusive licensed partner of MusclePharm in India. Get in touch for licensing, distribution and enterprise wholesale queries. For product-purchase enquiries, please head to Amazon India through our authorised sellers Nutriride and ADS Gallery.
              </p>
            </div>
          </SectionReveal>
        </div>
      </section>
    </>
  );
}
